import { Helmet } from "react-helmet";
import { styled } from "@mui/material/styles";
import { SMALL_TABLET_SCREEN_SIZE } from "../../../AppNavigation/constants";

const Site = styled("div")(({ theme }) => ({
  "*": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  margin: "auto",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  scrollSnapAlign: "start",
  ".faq_section": {
    width: "100%",
  },
  ".faq_content": {
    margin: "0 auto",
    maxWidth: 1369,
    width: "85.714286%",
    "&.faq_terms_head": {
      paddingTop: 100,
      paddingBottom: 100,
      ".faq_terms_head_left": {
        flex: 9,
        h1: {
          fontWeight: "bold",
          fontSize: 80,
          color: theme.vars.palette.text.primary,
          lineHeight: 1.16,
          marginBottom: 20,
        },
        h2: {
          fontSize: 36,
          fontWeight: 600,
          color: theme.vars.palette.text.primary,
          maxWidth: 600,
          lineHeight: 1.56,
        },
      },
      ".faq_terms_head_right": {
        flex: 3,
        img: {
          width: "100%",
        },
      },
    },
    "&.faq_terms": {
      display: "flex",
      flexDirection: "column",
      ".faq_terms_body": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        h1: {
          fontWeight: "bold",
          fontSize: 40,
          color: theme.vars.palette.text.primary,
          lineHeight: 2,
        },
        h2: {
          margin: "15px 0",
          fontWeight: "bold",
          lineHeight: 1.5,
          fontSize: 20,
          color: theme.vars.palette.text.primary,
        },
        h3: {
          margin: "15px 0",
          fontWeight: "bold",
          lineHeight: 1.5,
          fontSize: 16,
          color: theme.vars.palette.text.primary,
          textDecoration: "underline",
        },
        ".faq_title": {
          margin: 0,
          lineHeight: 1.2,
          marginTop: 100,
          fontSize: 40,
          fontWeight: "bold",
        },
        ".faq_q": {
          margin: 0,
          marginTop: 50,
          fontSize: 28,
          fontWeight: "bold",
        },
        ".faq_a": {
          margin: 0,
          marginTop: 15,
          fontSize: 16,
          fontWeight: 500,
          textDecoration: "none",
        },
      },
    },
  },
  "@media only screen and (max-width: 1279px)": {
    ".faq_content": {
      "&.faq_terms_head": {
        paddingTop: 100,
        paddingBottom: 0,
        ".faq_terms_head_left": {
          flex: 9,
          display: "flex",
          flexDirection: "column",
          h1: {
            fontSize: 40,
            marginBottom: 20,
          },
          h2: {
            fontSize: 16,
            width: "100%",
          },
        },
        ".faq_terms_head_right": {
          display: "none",
        },
      },
    },
  },
  [`@media only screen and (max-width: ${SMALL_TABLET_SCREEN_SIZE}px)`]: {
    ".faq_content": {
      "&.faq_terms_head": {
        paddingBottom: 50,
      },
      "&.faq_terms": {
        ".faq_terms_body": {
          ".faq_title": {
            marginTop: 60,
            fontSize: 36,
          },
          ".faq_q": {
            marginTop: 40,
            fontSize: 28,
          },
        },
      },
    },
  },
}));

const FaqHeader = () => {
  return (
    <div className="faq_section faq_terms_head" style={{}}>
      <div
        className="faq_content faq_terms_head"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div className="faq_terms_head_left">
          <h1>FAQs</h1>
          <h2>Helpful tips for getting started</h2>
        </div>
        <div className="faq_terms_head_right">
          <img
            src="https://media.brandclub.com/brandclub/image_asset/legal_faq.svg"
            alt="legal"
          />
        </div>
      </div>
    </div>
  );
};

const FaqContent = () => {
  return (
    <div className="faq_section faq_terms" style={{}}>
      <div className="faq_content_container" style={{}}>
        <div className="faq_content faq_terms">
          <div className="faq_terms_body">
            {/**REWARDS SECTION*/}
            <h1 className="faq_title">Rewards</h1>

            <h2 className="faq_q">How can I earn cash rewards?</h2>
            <h3 className="faq_a">
              You can earn rewards by taking surveys, referring friends,
              purchasing products, promoting products, and more.
            </h3>

            <h2 className="faq_q">
              Can I shop in-store and still receive rewards?
            </h2>
            <h3 className="faq_a">
              Yes, you can register your in-store purchases by linking them to
              your retailer account (e.g., entering your loyalty number). If
              your retailer accounts are connected, in-store purchases will
              automatically appear in your activity. If a purchase is missing,
              log in to your retailer account on a desktop and ensure the
              purchase appears in your purchase history. If it appears there, it
              should show up. If not, try syncing your retailer account again.
            </h3>

            <h2 className="faq_q">
              Why are my rewards locked? When will they become unlocked?
            </h2>
            <h3 className="faq_a">
              When certain rewards are earned, they may be in a "locked" status.
              These rewards can be unlocked and eligible for cash out after you
              make another eligible purchase.
            </h3>

            <h2 className="faq_q">
              I recently made a purchase, why am I not seeing the products in my
              account?
            </h2>
            <h3 className="faq_a">
              Purchases will appear once they are synced. To sync your account,
              tap the (+) icon in the navigation bar. If your purchases don’t
              appear after syncing, the products may not qualify for rewards. To
              qualify, there must be an active reward offer for the exact
              product at the time of purchase. The product also must be
              purchased from a participating retailer, as listed on the product
              page.
            </h3>

            <h2 className="faq_q">Will my unlocked rewards ever expire?</h2>
            <h3 className="faq_a">
              An unlocked reward will expire 180 days after it is earned.
            </h3>

            <h2 className="faq_q">Will my locked rewards ever expire?</h2>
            <h3 className="faq_a">
              A locked reward will expire 30-60 days after being earned.
            </h3>

            <h2 className="faq_q">
              Am I restricted to how many rewards I can earn?
            </h2>
            <h3 className="faq_a">
              There is no limit to the rewards you can earn.
            </h3>

            <h2 className="faq_q">
              What happens if I return a product where I earned rewards?
            </h2>
            <h3 className="faq_a">
              If a product return is initiated, any earned rewards associated
              with it will be reversed and reflected on your payout screen.
            </h3>

            <h2 className="faq_q">Why are my rewards pending?</h2>
            <h3 className="faq_a">
              Rewards will remain pending until the purchase is confirmed by the
              retailer, which can take 5-15 days. If rewards remain pending for
              more than 15 days, contact support for assistance.
            </h3>

            <h2 className="faq_q">How do I unlock my locked rewards?</h2>
            <h3 className="faq_a">
              To unlock your locked rewards, you will need to make another
              purchase. It’s a loyalty cycle, so every time you shop and make an
              eligible purchase, you’ll be rewarded.
            </h3>

            <h2 className="faq_q">
              How do I unlock my retailer connect reward?
            </h2>
            <h3 className="faq_a">
              To unlock your retailer connect reward, you must meet our minimum
              thresholds for regular activity. We recommend continuing to make
              purchases and syncing regularly. Once regular activity is
              detected, your rewards will be unlocked.
            </h3>

            <h2 className="faq_q">Can I make money for referring a friend?</h2>
            <h3 className="faq_a">
              Yes, we encourage you to invite others to join. You’ll earn
              rewards when friends sign up through your unique referral link and
              connect at least one active retailer account. You can find your
              referral link on the homepage.
            </h3>

            <h2 className="faq_q">How do I unlock my referral reward?</h2>
            <h3 className="faq_a">
              To unlock referral rewards, both you and your referred friend must
              complete account setup, which includes connecting at least one
              active retailer account.
            </h3>

            <h2 className="faq_q">What time are Daily Deals posted?</h2>
            <h3 className="faq_a">
              Daily Deals are posted at approximately 8 am PT.
            </h3>

            <h2 className="faq_q">
              Can I purchase a variation of the Daily Deal listed product?
            </h2>
            <h3 className="faq_a">
              No, you must purchase the exact featured product, not a different
              variation (e.g., color, size, flavor).
            </h3>

            <h2 className="faq_q">
              Can I purchase a Daily Deal with Subscribe and Save?
            </h2>
            <h3 className="faq_a">
              We do not recommend using Subscribe and Save to purchase Daily
              Deals.
            </h3>

            <h2 className="faq_q">How do I purchase the Daily Deal product?</h2>
            <h3 className="faq_a">
              Click the 'Buy' button, add the selected product to your bag,
              navigate to your bag, and proceed to checkout. Once the order is
              placed, your account will sync to claim the reward.
            </h3>

            {/**PAYOUTS SECTION*/}
            <h1 className="faq_title">Payouts</h1>

            <h2 className="faq_q">How are rewards paid out?</h2>
            <h3 className="faq_a">
              Rewards are paid out in US dollars, directly to your PayPal or
              Venmo account. No gift cards, points, or gimmicks.
            </h3>

            <h2 className="faq_q">
              I cashed out but do not see it in my Venmo or PayPal, so where is
              it?
            </h2>
            <h3 className="faq_a">
              Payouts are typically processed within 4-6 business days of
              submission. If it takes longer, please contact support so we can
              investigate.
            </h3>

            <h2 className="faq_q">
              Why do I need to input my credit card information to cash out?
            </h2>
            <h3 className="faq_a">
              Credit card information is required for identity verification when
              using PayPal or Venmo payouts. You only need to enter this
              information once. This data is secure, not shared, and your card
              will never be charged without your approval.
            </h3>

            <h2 className="faq_q">How much is the cash out fee?</h2>
            <h3 className="faq_a">All payouts incur a $1.50 processing fee.</h3>

            <h2 className="faq_q">How do I update my PayPal credentials?</h2>
            <h3 className="faq_a">
              {
                'To adjust your PayPal email credentials, navigate to Profile > Personal, and change your "Contact Email" to the associated PayPal email address.'
              }
            </h3>

            <h2 className="faq_q">Can I update my Venmo credentials?</h2>
            <h3 className="faq_a">
              Venmo payouts are sent to the phone number associated with your
              account. If your phone number differs from your Venmo phone
              number, we recommend using PayPal as an alternative to cash out.
            </h3>

            {/**CHECKOUT SECTION*/}
            <h1 className="faq_title">Checkout</h1>

            <h2 className="faq_q">
              Why is checkout not letting me add products to my bag?
            </h2>
            <h3 className="faq_a">
              If you are unable to add products to your bag, it may be because
              the retailer is not yet supported by checkout. If the retailer is
              supported, you may have reached the product’s quantity limit.
              Contact support if you need further assistance.
            </h3>

            <h2 className="faq_q">
              I purchased through checkout, but am having issues with my
              product(s), what do I do?
            </h2>
            <h3 className="faq_a">
              For shipping or order-related issues, please reach out directly to
              the retailer.
            </h3>

            <h2 className="faq_q">
              How do I return or exchange my products purchased through
              checkout?
            </h2>
            <h3 className="faq_a">
              To return or exchange products purchased through checkout, please
              process the return or exchange through the retailer from which the
              product was purchased.
            </h3>

            <h2 className="faq_q">How do I track my package?</h2>
            <h3 className="faq_a">
              You can track your packages through checkout via the order receipt
              or the retailer’s website.
            </h3>

            <h2 className="faq_q">How can I change my shipping address?</h2>
            <h3 className="faq_a">
              After clicking checkout, click the dropdown next to "Shipping
              Address" to switch the shipping address for your order.
            </h3>

            <h2 className="faq_q">How do I add products to my bag?</h2>
            <h3 className="faq_a">
              Simply click the "+Add" button on any product page to add to your
              bag.
            </h3>

            <h2 className="faq_q">
              Why do some products have the option to "View" at a retailer,
              while others I can add to my bag?
            </h2>
            <h3 className="faq_a">
              If a product only allows you to "View," this means the retailer is
              not yet supported by checkout.
            </h3>

            <h2 className="faq_q">How can I change my payment method?</h2>
            <h3 className="faq_a">
              After clicking checkout, click the dropdown next to "Payment
              Method" to switch your payment method for the order.
            </h3>

            <h2 className="faq_q">
              How do I look at my checkout order history?
            </h2>
            <h3 className="faq_a">
              Navigate to your profile and select "Purchases" to view your
              checkout order history.
            </h3>

            <h2 className="faq_q">
              Can I edit my existing retailer payment method and shipping
              addresses?
            </h2>
            <h3 className="faq_a">
              To edit existing payment methods or shipping addresses, you need
              to make those changes directly through the retailer.
            </h3>

            <h2 className="faq_q">
              Can I add a new retailer payment method to my checkout?
            </h2>
            <h3 className="faq_a">
              {
                'To add a new retailer payment method, click the dropdown next to "Payment Method" > select "Add new payment method" > and fill out the required information.'
              }
            </h3>

            <h2 className="faq_q">
              Can I add a new retailer shipping address to my checkout?
            </h2>
            <h3 className="faq_a">
              {
                'To add a new retailer shipping address, click the dropdown next to "Shipping Address" > select "Add new shipping address" > and fill out the address information.'
              }
            </h3>

            {/**RETAILER ACCOUNTS SECTION*/}
            <h1 className="faq_title">Retailer Accounts</h1>

            <h2 className="faq_q">What retailer accounts can I integrate?</h2>
            <h3 className="faq_a">
              We have connections with most major retailers and are continuously
              adding more. Visit the "Accounts" section to view our current
              retailer integrations.
            </h3>

            <h2 className="faq_q">
              How do I add a new retailer account? Is there a limit to how many
              I can add?
            </h2>
            <h3 className="faq_a">
              You can add new retailer accounts in the "Accounts" section.
              There’s no limit to the number of accounts you can add. We
              recommend adding all your accounts to maximize your cash-back
              opportunities. However, we limit the number of accounts per
              retailer to one. If you have multiple accounts for the same
              retailer, we recommend syncing the primary account you use. Once
              an account is synced, it cannot be synced with another account.
            </h3>

            <h2 className="faq_q">
              I am having trouble adding my retailer account. It says the login
              is already being used under another username. What should I do?
            </h2>
            <h3 className="faq_a">
              A retailer account can only be associated with one account. Once
              it’s synced, it cannot be removed.
            </h3>

            <h2 className="faq_q">
              I made a purchase but don't see the rewards in my account, why is
              this?
            </h2>
            <h3 className="faq_a">
              To earn rewards for your recent purchases, ensure your retailer
              accounts are connected. If they are connected, check if the
              purchase appears in your retailer account (by logging in on the
              retailer’s site). Once connected, visit frequently to sync your
              purchases and continue earning cash back.
            </h3>

            <h2 className="faq_q">How do I sync my accounts?</h2>
            <h3 className="faq_a">
              To sync your accounts, tap the (+) icon in the navigation bar.
            </h3>

            <h2 className="faq_q">
              I changed the password to one of my retailer accounts. How do I
              update this so I can earn rewards for my purchases?
            </h2>
            <h3 className="faq_a">
              The next time you sync your purchases, you’ll be prompted to enter
              your new password.
            </h3>

            {/**ACCOUNTS SECTION*/}
            <h1 className="faq_title">Account</h1>

            <h2 className="faq_q">How do I log in?</h2>
            <h3 className="faq_a">
              Once you've created your account, you can log in using your phone
              number.
            </h3>

            <h2 className="faq_q">How do I update my name?</h2>
            <h3 className="faq_a">
              {"You can update your name by navigating to Profile > Personal."}
            </h3>

            <h2 className="faq_q">How do I update my address?</h2>
            <h3 className="faq_a">
              {
                "You can update your address(es) by navigating to Profile > Addresses."
              }
            </h3>

            <h2 className="faq_q">How do I change my phone number?</h2>
            <h3 className="faq_a">
              To update your phone number, you can sign out of your account, tap
              "Sign in," and follow the instructions under the "Update your
              phone number" prompt.
            </h3>

            <h2 className="faq_q">How do I create an account?</h2>
            <h3 className="faq_a">
              To create an account, tap the "Sign up" button located on the app.
            </h3>

            <h2 className="faq_q">How many accounts can I have?</h2>
            <h3 className="faq_a">
              You may create only one account for personal use. If you need to
              make changes or updates to your account, please refer to the
              relevant articles. We are unable to transfer rewards from one
              account to another, and creating multiple accounts may result in
              the deactivation of all associated accounts. Please refer to our
              Terms of Service for more information.
            </h3>

            <h2 className="faq_q">How do I delete my account?</h2>
            <h3 className="faq_a">
              {
                "Once an account is deleted, the action cannot be undone. You can delete your account by navigating to Profile > Security > Delete Account."
              }
            </h3>

            <h2 className="faq_q">Can I log in with my email?</h2>
            <h3 className="faq_a">
              At this time, an active phone number is required for signing in to
              your account.
            </h3>

            <h2 className="faq_q">Where can I view the Terms of Service?</h2>
            <h3 className="faq_a">
              {
                "You can view the Terms of Service by navigating to Profile > Terms of Service. The Terms of Service are also available at brandclub.com/terms."
              }
            </h3>

            <h2 className="faq_q">Where can I view the Privacy Policy?</h2>
            <h3 className="faq_a">
              {
                "You can view the Privacy Policy by navigating to Profile > Privacy Policy. The Privacy Policy is also available at brandclub.com/privacy."
              }
            </h3>

            <h2 className="faq_q">How do I report unauthorized activity?</h2>
            <h3 className="faq_a">
              If you suspect unauthorized activity on your account, please
              contact support so our team can investigate.
            </h3>

            {/**CUSTOMER SUPPORT SECTION*/}
            <h1 className="faq_title">Customer Support</h1>

            <h2 className="faq_q">
              What is the response time for a customer support inquiry?
            </h2>
            <h3 className="faq_a">
              Our customer support team is committed to resolving your questions
              within 72 hours.
            </h3>

            <h2 className="faq_q">
              What are the customer support operating hours?
            </h2>
            <h3 className="faq_a">
              Customer support is available Monday-Friday from 8 am to 5 pm PT.
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

const Faq = () => {
  return (
    <Site>
      <Helmet>
        <title>FAQs</title>
        <meta name="description" content="Helpful tips for getting started." />
      </Helmet>
      <FaqHeader />
      <FaqContent />
    </Site>
  );
};
export default Faq;
